import { render, staticRenderFns } from "./succession-help.vue?vue&type=template&id=48e273c9&scoped=true&"
import script from "./succession-help.vue?vue&type=script&lang=js&"
export * from "./succession-help.vue?vue&type=script&lang=js&"
import style0 from "./succession-help.vue?vue&type=style&index=0&id=48e273c9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e273c9",
  null
  
)

export default component.exports